import { ecbrRequest } from '../../request/ecbrRequest'

export const companies = {
  getAll: async (...[params, ...rest]) =>
    ecbrRequest.get('/companies', { params }, ...rest),
  // getById: async (id) => ecbrApi.get(`/companies/${id}`),
  create: async (company) => ecbrRequest.post('/companies', company),
  // update: async (id, company) => ecbrApi.put(`/companies/${id}`, company),
  getByUserId: async (userId) => ecbrRequest.get(`/companies/user/${userId}`),
  getAllWithLoggedUser: async () => ecbrRequest.get('/companies/logged'),
  existsByCNPJ: async (cnpj) =>
    ecbrRequest.get(`/companies/exists?key=cnpj&value=${cnpj}`)
}
